<div class="container d-flex justify-content-center align-items-center">
  <form class="text-start d-flex flex-column gap-4 w-50" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h5 class="mb-4 fw-bold text-dark text-center">
      {{ 'USERS.CHANGE_PASSWORD' | translate }}
    </h5>

      <div>
      <p-password
        formControlName="currentPassword"
        inputValidator
        label="USERS.CURRENT_PASSWORD"
        [toggleMask]="true"
        [feedback]="false"
        inputStyleClass="form-control"
        styleClass="w-100"
      ></p-password> </div>

    <div>
      <p-password
        formControlName="newPassword"
        inputValidator
        label="USERS.NEW_PASSWORD"
        [toggleMask]="true"
        [feedback]="false"
        inputStyleClass="form-control"
        styleClass="w-100"
      ></p-password>
    </div>

    <div>
      <p-password
        formControlName="newPasswordConfirmation"
        inputValidator
        label="USERS.NEW_PASSWORD_CONFIRMATION"
        [toggleMask]="true"
        [feedback]="false"
        inputStyleClass="form-control"
        styleClass="w-100"
      ></p-password>
    </div>

    <div class="d-flex justify-content-start mt-4">
      <p-button
        [disabled]="form.invalid || isPending()"
        [loading]="isPending()"
        type="submit"
        styleClass="btn btn-primary px-4 py-2 fw-semibold"
        [label]="'MAIN.CHANGES_SAVE' | translate"
      ></p-button>
    </div>
  </form>
</div>
